import TeamHero from "../../components/team/TeamHero";
import TeamGrid from "../../components/team/TeamGrid";
import SeoHead from "@/components/seo/SeoHead";
import { breadcrumbJsonLd, seoFromPage } from "@/lib/seo";

const ADVISORY_MEMBERS = [
    {
        name: "Dr. Amara Singh",
        role: "Historical Consultant",
        bio: "An eminent scholar specializing in indentured labor history, Dr. Singh has published extensively on the social evolution of the Girmitiya diaspora.",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=800&auto=format&fit=crop",
    },
    {
        name: "Prof. Rajdeep Varma",
        role: "Cultural Anthropologist",
        bio: "Dedicated to preserving the intangible heritage of the diaspora, Professor Varma focuses on the linguistics and folk traditions of indentured communities.",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=800&auto=format&fit=crop",
    },
    {
        name: "Elena Rodriguez",
        role: "Global Policy Advisor",
        bio: "With two decades of experience in international heritage protection, Elena advises the council on global advocacy and partnership strategies.",
        image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=800&auto=format&fit=crop",
    },
    {
        name: "Dr. Samuel Okoro",
        role: "Archival Specialist",
        bio: "A pioneer in digital preservation, Dr. Okoro leads our efforts in digitizing rare colonial records and personal family archives.",
        image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=800&auto=format&fit=crop",
    },
    {
        name: "Meera Kulkarni",
        role: "Legal Heritage Consultant",
        bio: "Meera specializes in the legal rights of heritage preservation and helps navigate the complex frameworks of international cultural law.",
        image: "https://images.unsplash.com/photo-1598550874175-4d0ef436c909?q=80&w=800&auto=format&fit=crop",
    },
    {
        name: "Jameson Miller",
        role: "Economic Historian",
        bio: "Mr. Miller analyzes the economic contributions of the Girmitiya laborers to their host nations, providing a vital perspective on their global impact.",
        image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=800&auto=format&fit=crop",
    }
];

export default function AdvisoryBoardPage() {
    const seo = seoFromPage("teamAdvisory");

    return (
        <>
            <SeoHead
                {...seo}
                jsonLd={breadcrumbJsonLd([
                    { name: "Home", path: "/" },
                    { name: "Advisory Board", path: "/team/advisory-board" },
                ])}
            />
            <TeamHero 
                title="The Advisory Board"
                subtitle="Expertise & Vision"
                description="Our advisory board comprises global leaders in history, anthropology, and heritage preservation, guiding the council's mission with academic rigor and strategic foresight."
            />
            <TeamGrid members={ADVISORY_MEMBERS} />
        </>
    );
}
